import React, { Component } from 'react';
import { axiosInstance } from '../../utils/axiosInstance';


import { Edit, AddCircleOutline } from '@material-ui/icons/';
import { CustomDataTable } from '../../components/UI/CustomDataTable';
import { EnabledCell } from '../../components/UI/EnabledCell';

import Button from '@material-ui/core/Button';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from "react-router-dom";
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Delete } from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';
import swal from 'sweetalert'



export class Discount extends Component {

    constructor(props) {
        super(props);
        this.state = {
            columns:[],            
        };

        this.dataTableRef = React.createRef();
    } 


    async componentDidMount() {

        const columns = [
            {
                name: 'Id',
                selector: 'id',
                sortable: true,
                width: '90px',
                hide: 'sm',

            },

            {
                name: 'Descripción',
                selector: 'description',
                sortable: true,
            },
           
            {
                name: 'Producto',
                selector: 'product',
                sortable: true,
            },

            //{
            //    name: 'Texto superior',
            //    selector: 'labelThirdText',
            //    sortable: true,
            //},

            //{
            //    name: 'Texto inferior izquierda',
            //    selector: 'labelFirstText',
            //    sortable: true,
            //},

            //{
            //    name: 'Texto inferior derecha',
            //    selector: 'labelSecondText',
            //    sortable: true,
            //},


            {
                name: 'Lleva',
                selector: 'minimumAmount',
                sortable: true,
            },

            {
                name: 'Paga',
                selector: 'pay',
                sortable: true,
            },

            {
                name: 'Válido desde',
                selector: 'validFrom',
                sortable: true,
                hidden: 'sm'
            },


            {
                name: 'Válido hasta',
                selector: 'validUntil',
                sortable: true,
                hidden: 'sm'
            },

            {
                name: 'Días',
                selector: 'daysOfWeek',
                sortable: true,
                hidden: 'sm'
            },


            {
                name: 'Habilitado',
                selector: 'enabled',
                sortable: true,
                hidden: 'sm',
                maxwidth: '90px',
                cell: d => <EnabledCell enabled={d.enabled} />
            },


           
            {
                name: 'Opciones',
                button: true,
                cell: row =>
                    <Link to={"/EditandoOferta/" + row.id}>
                        <Tooltip title="Editar">
                            <IconButton aria-label="Editar">
                                <Edit />
                            </IconButton>
                        </Tooltip>
                    </Link>
                ,
                allowOverflow: true,
                width: '60px',
            },       
            {
                cell: row =>
                    <Tooltip title="Eliminar">
                        <IconButton
                            aria-label="delete"
                            onClick={this.handleDeleteClick}
                            data-row_id={row.id}
                            data-row_text={row.DiscountName}>
                            <Delete color="error" />
                        </IconButton>
                    </Tooltip>
                ,
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                width: '60px',
            },
        ];

        this.setState({
            columns: columns,                              
        });

      
    }

    

    handleDeleteClick = async e =>{

 

        var id = e.currentTarget.dataset.row_id;
        var text = e.currentTarget.dataset.row_text;

        const deleteRow = await swal({
            title: "¿Confirma la operación?",
            text: text,
            icon: "warning",
            dangerMode: true,
            buttons: true,

        });

        if (deleteRow) {

            await axiosInstance.delete('api/Offer/delete/' + id)
                .then(response => {

                    swal("Se eliminó el registro", {
                        icon: "success",
                    });
                    this.dataTableRef.current.refreshDataTable();

                }).catch(error => {

                    swal({
                        icon: 'error',
                        title: 'Oops, algo sucedió...',
                        text: error.response.data.message
                    })

                });


         
        }
    }

    onChange = (event, value) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    onSubmit = e => {

        e.preventDefault();
    }

    render() {


      
        return (



            <div>
                <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                        <h4>
                             Ofertas para OpenLab
                            <small >
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Typography color="inherit">
                                        Precios y ofertas
                                </Typography>
                                    <Typography color="textPrimary">Ofertas OpenLab</Typography>
                                </Breadcrumbs>
                            </small>
                        </h4>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <Link to="/NuevaOferta">
                            <Button variant="contained" color="primary" startIcon={<AddCircleOutline />} style={{ float: 'right' }}>
                                Nueva oferta
                        </Button>
                        </Link>
                    </Grid>
                </Grid>

                <hr/>

                <CustomDataTable
                    url="/api/Offer"
                    columns={this.state.columns}
                    handleOpenModal={this.handleOpenModal}
                    ref={this.dataTableRef}
                    showHeader={true}
                />
            </div>
        );
    }
}
